export enum ProfitType {
    ImprovingGrowth = 0,
    LessFalls = 1,
    LowerFeedConsumption = 2
}